var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var BN = require('bn.js');

var Algo = require("./algorithm");

var EC = require('elliptic').ec;

var nacl = require('tweetnacl');

var Codec = require('./codec');

var secp = new EC('secp256k1');

var Signature =
/*#__PURE__*/
function () {
  "use strict";

  function Signature(info, keyPair) {
    _classCallCheck(this, Signature);

    if (!info) {
      this.algorithm = undefined;
      this.pubkey = undefined;
      this.sig = undefined;
      return;
    }

    this.algorithm = keyPair.t;

    if (this.algorithm === Algo.Ed25519) {
      this.sig = Buffer.from(nacl.sign(info, keyPair.seckey)).slice(0, 64);
      this.pubkey = keyPair.pubkey;
    } else if (this.algorithm === Algo.Secp256k1) {
      var secpKey = secp.keyFromPrivate(keyPair.seckey);
      this.pubkey = keyPair.pubkey;
      var sig = secpKey.sign(info);
      var r = sig.r;
      var n = new BN("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
      var s = n.sub(sig.s);

      if (s.gt(sig.s)) {
        s = sig.s;
      }

      this.sig = Buffer.concat([Buffer.from(r.toArray()), Buffer.from(s.toArray())]);
    } else {
      throw 'type error!';
    }
  }

  _createClass(Signature, [{
    key: "_bytes",
    value: function _bytes() {
      var c = new Codec();
      c.pushByte(this.algorithm);
      c.pushBytes(this.sig);
      c.pushBytes(this.pubkey);
      return c._buf;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        algorithm: this.algorithm === 1 ? "SECP256K1" : "ED25519",
        public_key: this.pubkey.toString('base64'),
        signature: this.sig.toString('base64')
      };
    }
  }, {
    key: "verify",
    value: function verify(info) {
      if (this.algorithm === Algo.Ed25519) {
        return nacl.sign.detached.verify(info, this.sig, this.pubkey);
      }

      if (this.algorithm === Algo.Secp256k1) {
        var r = new BN(this.sig.slice(0, 32).toString('hex'), 16);
        var s = new BN(this.sig.slice(32, 64).toString('hex'), 16);
        var sig = {
          r: r,
          s: s
        };
        return secp.verify(info, sig, this.pubkey);
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      var obj = JSON.parse(json);
      var sig = {
        algorithm: obj.algorithm === "ED25519" ? 2 : 1,
        pubkey: Buffer.from(obj.public_key, "base64"),
        sig: Buffer.from(obj.signature, "base64")
      };
      return Object.assign(new Signature(), sig);
    }
  }]);

  return Signature;
}();

module.exports = Signature;